import React, { useEffect, useRef } from "react";
import { formatDateTime } from "./rootDashboardUtils";

const levelClass = (level) => {
  if (level === "error") return "is-error";
  if (level === "warning") return "is-warning";
  return "";
};

export default function RootLogsConsole({ logs = [], loading, error, onRefresh }) {
  const listRef = useRef(null);

  useEffect(() => {
    if (!listRef.current) return;
    listRef.current.scrollTop = 0;
  }, [logs]);

  return (
    <div className="management-card root-section-card" id="root-logs">
      <div className="root-card-header">
        <div>
          <h6 className="root-card-title mb-1">Consola frontend</h6>
          <small className="text-muted">Warnings y errores recientes</small>
        </div>
        <button className="btn root-refresh-btn btn-sm" type="button" onClick={onRefresh} disabled={loading}>
          <i className="bi bi-arrow-repeat me-1" />
          {loading ? "Cargando..." : "Actualizar"}
        </button>
      </div>

      {error && (
        <div className="root-console-error text-muted mb-2">
          <i className="bi bi-exclamation-triangle me-2" />
          {error}
        </div>
      )}

      <div className="root-console" ref={listRef}>
        {logs.length ? (
          logs.map((log) => (
            <div key={log.id} className={`root-console-line ${levelClass(log.nivel)}`}>
              <span className="root-console-time">{formatDateTime(log.created_at)}</span>
              <span className="root-console-level">{log.nivel?.toUpperCase()}</span>
              <span className="root-console-route">{log.ruta || "-"}</span>
              <span className="root-console-message">{log.mensaje}</span>
              {log.nombre_completo || log.email ? (
                <span className="root-console-user">
                  {log.nombre_completo || log.email}
                </span>
              ) : null}
            </div>
          ))
        ) : (
          <div className="root-console-empty text-muted">Sin logs recientes</div>
        )}
      </div>
    </div>
  );
}
